import { render, staticRenderFns } from "./ConsultPage.vue?vue&type=template&id=1a1fbb7c&"
import script from "./ConsultPage.vue?vue&type=script&lang=js&"
export * from "./ConsultPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsultPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports